import { ChartAction } from "../action";
import { FormInstance } from "antd";
import { toTitle } from "@src/helpers/text-helper";

export const FunnelShowMore: React.FC<{ form: FormInstance }> = ({ form }) => {
  return <ChartAction tabKey={"funnel-table"} tabName={toTitle("funnel-table")} form={form} />;
};
